import * as React from "react";
import {Navbar} from "baziigram"
import {navigate} from "gatsby-link";
import {useDispatch} from "react-redux";
import {dictionary} from "../../constants";
import {useEffect, useState} from "react";
import {Util} from "baziigram"
import {getUser} from "../../Util/user"

const DeveloperNavbar = ({ page , backUrl="/"}) => {

const language=Util.getLanguage();

    const [menus,setMenus] = useState([
    {title:dictionary.navBarMenu[2][language], action:()=>navigate("/Rules")},
    {title:dictionary.navBarMenu[3][language], action:()=>navigate("/Help")},

    ])

    useEffect(()=>{
        let user = getUser()

      if(menus.length<3){
      if(Object.keys(user).length>0 )
      setMenus([{title:dictionary.navBarMenu[1][language], action:()=>navigate("/DeveloperDashboard")}].concat(menus))

      else
      setMenus([{title:dictionary.navBarMenu[0][language], action:()=>navigate("/Login")}].concat(menus))
      }
    },[])



    return (
        <Navbar menus={menus} page={page}/>
    );
};

export default DeveloperNavbar;
